import React, { useState, useEffect, useRef } from 'react'
import {
  CFormInput,
  CButton,
  CFormSelect,
  CTable,
  CToast,
  CToastBody,
  CToaster,
} from '@coreui/react'
import MUIDataTable from 'mui-datatables'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { CSSProperties } from 'react'
import GridLoader from 'react-spinners/GridLoader'
import { ShimmerTable } from 'react-shimmer-effects'
import Modal from 'react-modal'
import ReactPaginate from 'react-paginate'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AiOutlineAppstoreAdd } from 'react-icons/ai'
import { FaEye } from 'react-icons/fa'
import { MdDeleteOutline } from 'react-icons/md'
import { CiEdit } from 'react-icons/ci'
import { accessLevel } from 'src/utils'
import BussinessFilter from './Filter/BusinessFIlter'
import ApplicationsFilter from './Filter/ApplicationsFilter'
import UsersFilter from './Filter/UsersFIlter'
import CreatedOnFilter from './Filter/CreatedOnFIlter'

const BusinessUnits = () => {
  //const [toast, addToast] = useState(0)
  const navigate = useNavigate()

  const [businessUnits, setBusinessUnits] = useState([])
  const [onLoading, setOnLoading] = useState(false)

  const [pageCount, setPageCount] = useState(100)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(100)
  const [onDeleting, setOnDeleting] = useState(false)

  const [businessUnitToDelete, setBusinessUnitToDelete] = useState(null)
  const [modalIsOpen, setModalIsOpen] = React.useState(false)

  const [accessLevelRole, setAccessLevelRole] = useState(null)

  const [page, setPage] = useState(0)
  const [count, setCount] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [searchInput, setSearchInput] = useState('')

  const [filterList, setFilterList] = useState({})
  const [filterOptions, setFilterOptions] = useState({
    roles: [],
    statuses: [],
    locations: [],
    businessUnits: [],
  })

  const customStyles = {
    content: {
      top: '30%',
      left: '25%',
      width: '50%',
      right: 'auto',
      bottom: 'auto',
      height: '25%',
      backgroundColor: '#ffffff',
      borderRadius: 15,
      borderColor: 'ffffff',
    },
  }

  // Function to handle the button click and show the confirm dialog
  const handleClick = (user) => {
    setBusinessUnitToDelete(user)
    setModalIsOpen(true)
  }

  const goToEditBusinessUnit = (id) => {
    navigate('/edit-business-unit?businessUnitId=' + id)
  }

  // Function to handle the confirmation action
  const handleConfirmation = (confirmed) => {
    if (confirmed) {
      // Call the function with the value passed to this component
      deleteFunction(businessUnitToDelete)
    }
    setModalIsOpen(false)
  }

  // Function to delete the business unit
  const deleteFunction = (app) => {
    deletebusinessUnit(app)
  }

  const closeModal = async () => {
    setModalIsOpen(false)
  }

  const deletebusinessUnit = async (id) => {
    // Construct the request body
    const requestBody = {
      id: id,
    }

    // Retrieve the bearer token from sessionStorage
    const bearerToken = sessionStorage.getItem('ASIToken')

    try {
      const response = await axios.delete('/api/v1/organizations/business-units', {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
        data: requestBody,
      })

      // Handle the API response
      setOnDeleting(false)

      if (response.data.hasOwnProperty('error')) {
        toast.error(response.data.error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        })

        setOnDeleting(false)
      } else {
        toast('Business unit deleted', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        })

        setOnDeleting(false)

        // Update the business units array by removing the deleted business unit
        setBusinessUnits((prevBusinessUnits) => {
          return prevBusinessUnits.filter((app) => app._id !== id)
        })

        fetchBusinessUnits()
      }
    } catch (error) {
      // Handle API error
      console.error('Error:', error)
      setOnDeleting(false)
    }
  }

  const toaster = useRef()
  const exampleToast = (
    <CToast>
      <CToastBody>Success</CToastBody>
    </CToast>
  )

  const override: CSSProperties = {
    display: 'block',
    margin: '0 auto',
    borderColor: 'red',
  }

  const isFirstTime = useRef(true)

  const fetchBusinessUnits = async (
    isFirstTime,
    currentPage,
    rowsPerPage,
    searchText,
    filterList,
  ) => {
    if (isFirstTime) {
      setOnLoading(true)
    }

    const queryParams = new URLSearchParams({
      page,
      rowsPerPage,
    })

    if (searchText) {
      queryParams.append('search', searchText)
    }

    if (filterList !== undefined && filterList != null && Object.keys(filterList).length > 0) {
      queryParams.append('filterList', JSON.stringify(filterList))
    }

    const token = sessionStorage.getItem('ASIToken')
    const response = await axios.get(
      `/api/v1/organizations/business-units/all/all?${queryParams.toString()}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    )

    console.log('DSfsd', response.data.businessUnits)
    // setBusinessUnits(response.data.businessUnits)
    setBusinessUnits(
      response.data.businessUnits.map((app) => ({
        ...app,
        businessUnit1: app?.name || '',
        usersCount: app?.usersCount || '',
        appsCount1: app?.appsCount || '',
        createdOn1: app?.createdAt || '',
      })),
    )
    setFilterOptions(response.data.filterOptions)

    setOnLoading(false)
  }

  const [user, setUser] = useState({})

  useEffect(() => {
    getUserDetails()

    const role = accessLevel()
    setAccessLevelRole(role)
  }, [])

  const getUserDetails = () => {
    setUser(JSON.parse(sessionStorage.getItem('ASIUser')))
  }

  const goToAddBusinessUnit = async () => {
    navigate('/add-business-unit')
  }

  useEffect(() => {
    // Make the initial call immediately
    fetchBusinessUnits(true, currentPage, rowsPerPage, filterList)
  }, [])

  const columns = [
    {
      label: '#',
      options: {
        filter: false,
        download: true,
      },
    },
    // 'Business Unit Name',
    // 'Applications',
    // 'Users',
    // 'Created On',

    {
      name: 'business Unit Name',
      label: 'Business Unit Name',
      options: {
        filter: true,
        download: true,
        // sort: true,
        filterType: 'custom',
        filterList: filterList['Business Unit Name'] || [],
        customBodyRender: (value) => value || '',
        filterOptions: {
          names: filterOptions.unitsBusiness,
          logic: (value, selected) => {
            if (!selected || selected.length === 0) return false
            return !selected.includes(value)
          },
          display: (filterList, onChange, index, column) => (
            <BussinessFilter
              filterList={filterList[index] || []}
              onChange={onChange}
              index={index}
              column={column}
              filterOptions={filterOptions}
            />
          ),
        },
        setCellProps: () => ({ style: { textAlign: 'center' } }),
        setCellHeaderProps: () => ({ style: { textAlign: 'center' } }),
      },
    },
    {
      name: 'users',
      label: 'Users Count',
      options: {
        filter: true,
        download: true,
        // sort: true,
        filterType: 'custom',
        filterList: filterList['Users Count'] || [],
        customBodyRender: (value) => value || '0',
        filterOptions: {
          names: filterOptions.countUsers,
          logic: (value, selected) => {
            if (!selected || selected.length === 0) return false
            return !selected.includes(value)
          },
          display: (filterList, onChange, index, column) => (
            <UsersFilter
              filterList={filterList[index] || []}
              onChange={onChange}
              index={index}
              column={column}
              filterOptions={filterOptions}
            />
          ),
        },
        setCellProps: () => ({ style: { textAlign: 'center' } }),
        setCellHeaderProps: () => ({ style: { textAlign: 'center' } }),
      },
    },

    {
      name: 'appsCount',
      label: 'Apps Count',
      options: {
        filter: true,
        download: true,
        // sort: true,
        filterType: 'custom',
        filterList: filterList['Apps Count'] || [],
        customBodyRender: (value) => value || '0',
        filterOptions: {
          names: filterOptions.countApps,
          logic: (value, selected) => {
            if (!selected || selected.length === 0) return false
            return !selected.includes(value)
          },
          display: (filterList, onChange, index, column) => (
            <ApplicationsFilter
              filterList={filterList[index] || []}
              onChange={onChange}
              index={index}
              column={column}
              filterOptions={filterOptions}
            />
          ),
        },
        setCellProps: () => ({ style: { textAlign: 'center' } }),
        setCellHeaderProps: () => ({ style: { textAlign: 'center' } }),
      },
    },

    {
      name: 'created On',
      label: 'Created At',
      options: {
        filter: true,
        download: true,
        // sort: true,
        filterType: 'custom',
        filterList: filterList['Created At'] || [],
        customBodyRender: (value) => value || '---',
        filterOptions: {
          names: filterOptions.createdAt,
          logic: (value, selected) => {
            if (!selected || selected.length === 0) return false
            return !selected.includes(value)
          },
          display: (filterList, onChange, index, column) => (
            <CreatedOnFilter
              filterList={filterList[index] || []}
              onChange={onChange}
              index={index}
              column={column}
              filterOptions={filterOptions}
            />
          ),
        },
        setCellProps: () => ({ style: { textAlign: 'center' } }),
        setCellHeaderProps: () => ({ style: { textAlign: 'center' } }),
      },
    },
    {
      name: 'businessUnit1',
      label: 'Business Unit Name',
      options: {
        filter: false,
        sort: true,
        download: true,
        display: false,
        customBodyRender: (value) => value.name || '---',
      },
    },
    {
      name: 'usersCount',
      label: 'Users Count',
      options: {
        filter: false,
        sort: true,
        download: true,
        display: false,
        customBodyRender: (value) => value?.usersCount || '---',
      },
    },
    {
      name: 'appsCount1',
      label: 'Apps Count',
      options: {
        filter: false,
        sort: true,
        download: true,
        display: false,

        customBodyRender: (value) => value?.appsCount || '---',
      },
    },

    {
      name: 'createdOn1',
      label: 'Created At',
      options: {
        filter: false,
        sort: true,
        download: true,
        display: false,

        customBodyRender: (value) => value?.createdAt || '---',
      },
    },
    {
      label: 'Actions',
      options: {
        filter: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {(accessLevelRole == 'Administrator' || accessLevelRole == 'Application Manager') && (
                <>
                  <CButton
                    color="info"
                    onClick={() => goToEditBusinessUnit(value)}
                    variant="outline"
                    className="m-1"
                    style={{
                      width: 100,
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: 'blue',
                      borderColor: 'blue',
                    }}
                  >
                    <CiEdit size={15} style={{ color: 'white' }} />
                    <span style={{ marginLeft: 5 }}></span>
                  </CButton>

                  <CButton
                    color="danger"
                    onClick={() => handleClick(value)}
                    variant="outline"
                    className="m-1"
                    style={{
                      width: 100,
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: 'red',
                      borderColor: 'red',
                    }}
                  >
                    <MdDeleteOutline size={15} style={{ color: 'white' }} />
                    <span style={{ marginLeft: 5 }}></span>
                  </CButton>
                </>
              )}
            </div>
          )
        },
      },
    },
  ]

  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              textAlign: 'left',
              '&:nth-child(1)': {
                width: 30,
              },
            },
          },
        },
        MUIDataTableHeadCell: {
          styleOverrides: {
            root: {
              textAlign: 'left',
              '&:nth-child(1)': {
                width: 30,
              },
            },
          },
        },
      },
    })

  const options = {
    filterType: 'dropdown',
    responsive: 'stacked',
    elevation: 0, //for table shadow box
    filter: true,
    download: true,
    print: false,
    downloadOptions: {
      filename: 'Business Units.csv',
      separator: ',',
    },
    search: true,
    searchOpen: true,
    viewColumns: true,
    selectableRows: false, // <===== will turn off checkboxes in rows
    rowsPerPageOptions: [10, 20, 60, 100, 150],
    pagination: false,
    serverSide: true,
    count: count,
    page: page,
    rowsPerPage: rowsPerPage,
    // textLabels: {
    //   body: {
    //     noMatch: 'No business units created yet',
    //   },
    // },
    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '8px 16px',
          }}
        >
          <input
            type="text"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                setSearchText(searchInput)
                setPage(0)
                fetchBusinessUnits(true, 0, rowsPerPage, searchInput, filterList)
              }
            }}
            placeholder="Search applications..."
            style={{
              padding: '8px 12px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              width: '300px',
              fontSize: '14px',
              color: '#000',
            }}
          />
          <button
            onClick={() => {
              setSearchText(searchInput)
              setPage(0)
              fetchBusinessUnits(true, 0, rowsPerPage, searchInput, filterList)
            }}
            style={{
              padding: '8px 16px',
              borderRadius: '4px',
              border: 'none',
              backgroundColor: '#1976d2',
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Search
          </button>
          {searchInput && (
            <button
              onClick={() => {
                setSearchInput('')
                setSearchText('')
                setPage(0)
                fetchBusinessUnits(true, 0, rowsPerPage, '', filterList)
              }}
              style={{
                padding: '8px 16px',
                borderRadius: '4px',
                border: 'none',
                backgroundColor: '#d32f2f',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              Clear
            </button>
          )}
        </div>
      )
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          setPage(tableState.page)
          fetchBusinessUnits(true, tableState.page, tableState.rowsPerPage, searchText, filterList)
          break

        case 'changeRowsPerPage':
          setRowsPerPage(tableState.rowsPerPage)
          setPage(0)
          fetchBusinessUnits(true, 0, tableState.rowsPerPage, searchText, filterList)
          break

        case 'filterChange':
          const newFilterList = {}
          tableState.filterList.forEach((filter, index) => {
            if (filter && filter.length) {
              newFilterList[columns[index].label] = filter
            }
          })
          setFilterList(newFilterList)
          setPage(0)
          fetchBusinessUnits(true, 0, tableState.rowsPerPage, searchText, newFilterList)
          break

        case 'resetFilters':
          setFilterList({})
          setPage(0)
          fetchBusinessUnits(true, 0, tableState.rowsPerPage, searchText, {})
          break
      }
    },
  }

  var tableData = []

  for (var i = 0; i < businessUnits.length; i++) {
    var dataItem = []

    dataItem.push(i + 1)
    dataItem.push(businessUnits[i].name)
    dataItem.push(businessUnits[i].usersCount)

    dataItem.push(businessUnits[i].appsCount)
    dataItem.push(new Date(businessUnits[i].createdAt).toLocaleDateString('en-US'))

    dataItem.push(businessUnits[i]._id) // for delete

    tableData.push(dataItem)
  }

  return (
    <div className="activeScans">
      {setModalIsOpen && (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Remediations"
        >
          <text style={{ color: '#000', fontSize: 18 }}>
            Are you sure you want to permanently delete this business unit?
          </text>
          <br />
          <br />
          <button
            onClick={() => handleConfirmation(true)}
            style={{
              width: 100,
              borderWidth: 0,
              borderRadius: 5,
              backgroundColor: 'green',
              color: 'white',
              padding: 10,
            }}
          >
            Yes
          </button>
          <button
            onClick={() => handleConfirmation(false)}
            style={{
              marginLeft: 30,
              borderWidth: 0,
              borderRadius: 5,
              width: 100,
              backgroundColor: 'red',
              color: 'white',
              padding: 10,
            }}
          >
            No
          </button>
        </Modal>
      )}

      <div style={{ width: '100%' }}>
        <div>
          <div
            style={{
              marginBottom: '2rem',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <h4>
              <strong>Business Unit</strong>
            </h4>

            {(accessLevelRole == 'Administrator' || accessLevelRole == 'Application Manager') && (
              <CButton
                style={{
                  width: 200,
                  marginBottom: '2%',
                  borderWidth: 0,
                  fontSize: 13,
                  background: '#e50202',
                }}
                onClick={goToAddBusinessUnit}
                color="primary"
                className="px-3"
              >
                <AiOutlineAppstoreAdd size={24} style={{ color: 'white' }} />
                <span style={{ marginLeft: 15 }}>Add a Business Unit</span>
              </CButton>
            )}
          </div>

          {onLoading && <ShimmerTable row={8} col={10} />}

          {!onLoading && (
            <>
              <ThemeProvider theme={getMuiTheme()}>
                <MUIDataTable
                  style={{ height: '57vh' }}
                  data={tableData}
                  columns={columns}
                  options={options}
                />
              </ThemeProvider>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default BusinessUnits
